function Skills() {
    return (
        <div className="flex flex-col items-center w-screen bg-black text-nowrap">
            <div className="flex flex-col justify-end max-w-[1200px] w-full flex flex-col px-7">
                <div className="text-white text-4xl lg:text-5xl font-bold pt-20">
                    [ SKILLS ]
                </div>
                <div className="text-white text-3xl font-bold pt-7 pb-4">
                    Languages
                </div>
                <div className="flex flex-row flex-wrap gap-2 text-white">
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Python
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        JavaScript
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Java
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        C/C++
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Swift
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        TypeScript
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        HTML
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        CSS
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Solidity
                    </div>
                </div>
                <div className="text-white text-3xl font-bold pt-7 pb-4">
                    Front-End
                </div>
                <div className="flex flex-row flex-wrap gap-2 text-white">
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        React
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        React Native
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Next.js
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Tailwind CSS
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Material UI
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Chakra UI
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Ant Design
                    </div>
                </div>
                <div className="text-white text-3xl font-bold pt-7 pb-4">
                    Back-End
                </div>
                <div className="flex flex-row flex-wrap gap-2 text-white">
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Node.js
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Express
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        REST
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        MongoDB
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Firebase
                    </div>
                </div>
                <div className="text-white text-3xl font-bold pt-7 pb-4">
                    DevOps
                </div>
                <div className="flex flex-row flex-wrap gap-2 text-white">
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        AWS
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Azure
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Heroku
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Docker
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Vercel
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Netlify
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Selenium
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Terraform
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        CloudFormation
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Google Cloud Functions
                    </div>
                </div>
                <div className="text-white text-3xl font-bold pt-7 pb-4">
                    Other Tools & Services
                </div>
                <div className="flex flex-row flex-wrap gap-2 text-white">
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Git
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Figma
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        TensorFlow
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        OpenCV
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Jupyter Notebook
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Papertrail
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Hardhat
                    </div>
                    <div className="bg-neutral-800 px-5 rounded-full text-lg flex items-center justify-center h-10">
                        Truffle Suite
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Skills;
